import React, { useEffect } from "react";
import "../css/publications.css";
import AOS from "aos";
import "aos/dist/aos.css";
import about2 from '../../assets/img/about-2.png'

function Blogs() {
      useEffect(() => {
        AOS.init({
          duration: 1000,
          easing: "ease-in-out",
        });
      }, []);
  return (
    <div>
  <section className="about-hero" data-aos="fade-up">
        <div className="hero-bg"></div>
        <div className="hero-content text-center text-white">
          <div className="container">
            <h1 className="fw-bold text-white">Blogs</h1>
            <p className="mt-3">
              Insights, legal analysis, and publications reflecting our
              expertise
            </p>
          </div>
        </div>
      </section>
      <section className="articles-wrapper" data-aos="fade-up" data-aos-delay="200">
  <div className="container">

    <h2 className="articles-heading">Blogs</h2>

    <div className="row g-4">

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
            <img  src={about2}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          <div className="article-meta">
            <span className="article-date">December 23, 2025</span>
          </div>

          <h5 className="article-title">
            Redefining Work: Karnataka’s trailblazing move toward gender equity
          </h5>
        </div>
      </div>

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
           <img  src={about2}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          <div className="article-meta">
            <span className="article-date">December 23, 2025</span>
          </div>

          <h5 className="article-title">
            The Shanti Act opens a nuclear pathway – Let’s proceed with care
          </h5>
        </div>
      </div>

      {/* Article Card */}
      <div className="col-md-6 col-lg-4">
        <div className="article-card">
          <div className="article-img">
             <img  src={about2}  alt="Law Image 1"  className="img-fluid hover-effect"/>
          </div>

          <div className="article-meta">
          
            <span className="article-date">December 19, 2025</span>
          </div>

          <h5 className="article-title">
            India’s satcom sector poised for a decade of steady growth
          </h5>
        </div>
      </div>

    </div>
  </div>
</section>

    </div>
  )
}

export default Blogs